import resolve from '../../../../common/utils/object/resolve'

const sentinels = {
    '${notEmpty}': (fieldValue) => !fieldValue,
}

const validateWarning = (warning, data) => {
    if (!warning || !data) return false
    const fieldValue = resolve(warning.field, data)
    const sentinel = sentinels[warning.compareField]
    if (sentinel) return sentinel(fieldValue)
    return fieldValue !== resolve(warning.compareField, data)
}

export default validateWarning
